module.exports = __webpack_public_path__ + "static/media/share.fa8c41dc.png";